import React, {PureComponent} from 'react';
import {Form, Icon, Input} from 'antd';
import {RTLCol} from '../RTLKit';


export default class TextField extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        const {
            input,
            label,
            iconName,
            type,
            placeholder,
            disabled,
            meta: {touched, error, warning},
        } = this.props;

        let defaultValue = null
        if(input.value)
            defaultValue = input.value

        return (
            <RTLCol span={24}>
                <RTLCol className="formLabel" md={label ? 5 : 0} sm={24}>
                    {label ? <label>{label} : </label> : null}
                </RTLCol>
                <RTLCol md={label ? 18 : 24} sm={24}>
                    <Form.Item hasFeedback validateStatus={(touched && error) ? 'error' : ''} help={touched && error}>
                        <Input
                            {...input}
                            prefix={<Icon type={iconName} style={{color: 'rgba(0,0,0,.25)'}}/>}
                            placeholder={ placeholder}
                            type={type}
                            disabled={disabled}
                            value={defaultValue}
                        />
                    </Form.Item>
                </RTLCol>
            </RTLCol>
        );
    }
}



